module.exports = __webpack_public_path__ + "static/media/storeShirt.8222a8e7.svg";